import { render, staticRenderFns } from "./CasesOverview.vue?vue&type=template&id=7c1a67ec&scoped=true&"
import script from "./CasesOverview.vue?vue&type=script&lang=ts&"
export * from "./CasesOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1a67ec",
  null
  
)

export default component.exports